// src/pages/JoinRoom.js
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function JoinRoom({ user }) {
  const { roomId, pw } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      // 로그인된 상태라면 바로 방으로 이동
      navigate(`/rooms/${roomId}?pw=${encodeURIComponent(pw)}`, { replace: true });
    } else {
      // 로그인 전이면 Intro로 보내서 로그인 후 다시 이 URL로 돌아오게
      navigate('/login', { replace: true });
    }
  }, [user, roomId, pw, navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      <p>방에 입장하는 중입니다…</p>
    </div>
  );
}
